import { Maneuver } from '@kinetic-ui/data-layer';
import Delete from '@mui/icons-material/Delete';
import { Box, IconButton, Typography } from '@mui/material';
import { FunctionComponent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { RecursivePartial } from 'types';
import { MANEUVERS_FORM_ID } from '../../../const';
import { LocationFormContext } from '../../../context';
import { useSelectedManeuver } from '../hooks/useSelectedManeuver';
import { useStyles } from '../styles';

const DeleteButton = ({ id }: { id?: string }) => {
  const { setValues, setDirty } = useContext(LocationFormContext);
  const { selectedManeuver, setSelectedManeuver } = useSelectedManeuver();

  const handleDelete = () => {
    if (id) {
      // unselect the maneuver on the map if it is selected
      if (selectedManeuver?.id === id) {
        setSelectedManeuver(undefined);
      }
      // update form values
      setDirty(MANEUVERS_FORM_ID, true);
      setValues((prev) => ({
        ...prev,
        maneuvers: prev.maneuvers?.filter((maneuver) => maneuver.id !== id),
      }));
    }
  };

  return (
    <IconButton size='small' onClick={handleDelete}>
      <Delete fontSize='inherit' />
    </IconButton>
  );
};

export const ManeuversByLane: FunctionComponent<{ maneuvers: RecursivePartial<Maneuver>[] }> = ({
  maneuvers,
}) => {
  const { t } = useTranslation('locations');
  const classes = useStyles();
  const { values } = useContext(LocationFormContext);

  const findLaneById = (id?: string) => values?.lanes?.find((lane) => lane.id === id);

  return (
    <Box className={classes.lane}>
      {maneuvers.map(({ id, refApproachLane, refDepartureLane }) => {
        const approachLane = findLaneById(refApproachLane);
        const departureLane = findLaneById(refDepartureLane);
        return (
          <Box className={classes.maneuver} key={`${refDepartureLane}-${refApproachLane}`}>
            <Typography>
              {t('maneuverFromTo', {
                from: approachLane?.description,
                to: departureLane?.description,
              })}
            </Typography>
            <DeleteButton id={id} />
          </Box>
        );
      })}
    </Box>
  );
};
